module.exports = __webpack_public_path__ + "static/backdrop@2x-b7bc5bf47289c8294324d54c7d88d6d8.png";